import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { SecondaryButton } from 'components/Shared/Button'
import { useGoogleTestCampaignContext } from './testCampaignContext'
import { canEnableGoogleTestCampaign } from './testCampaignUtils'

export default function GoogleTestCampaignButton({ assets, disabled = false }) {
  const { t } = useTranslation()
  const { openModal } = useGoogleTestCampaignContext()

  const isEnabled = canEnableGoogleTestCampaign(assets)

  return (
    <SecondaryButton
      className="ad-platform_connection__buttons__item"
      onClick={openModal}
      text={t('Settings.GoogleAccess.TestCampaign.runTestCampaign', 'Run Test Campaign')}
      disabled={!isEnabled || disabled}
      disabledTitle={t(
        'Settings.GoogleAccess.TestCampaign.runTestCampaignDisabled',
        'Connect a Google Ads account to run a test campaign',
      )}
      color="orange"
      fullWidth={false}
      size="small"
    />
  )
}

GoogleTestCampaignButton.propTypes = {
  assets: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
}
